export * from './gutachten-delete-request.interface';
export * from './gutachten-delete-response.interface';
export * from './gutachten-delete.shapes';
